export default __webpack_public_path__ + "static/media/workshopp.e0c8b572.jpg";